// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__Qj6Pk","buttons":"PendingPaymentAlert_buttons__3rfCO"};